import { QueryClient } from '@tanstack/react-query';
import { get, set, del } from 'idb-keyval';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

// IDB persister for TanStack Query — survives page refresh.
// Wired into PersistQueryClientProvider in src/main.tsx.
export const idbPersister = {
  persistClient: async (client: unknown) => {
    await set('tq-cache', client);
  },
  restoreClient: async () => {
    return await get('tq-cache');
  },
  removeClient: async () => {
    await del('tq-cache');
  },
};
